import { SET_AUTH, PURGE_AUTH, SET_ERROR, SET_LOADING, SET_LOGOUT_ACC_FREE, SET_LOGIN_POPUP, SET_TOGGLE_LOGIN_POPUP, SET_TOGGLE_LOGIN_SSO_POPUP } from "./constants";

export default {
  [SET_LOADING](state, value) {
    state.isLoading = value;
  },
  [SET_ERROR](state, errors) {
    state.errors = errors;
  },
  [SET_AUTH](state, user) {
    // state.isLoggedIn = true;
    state.user = user;
    state.errors = [];
  },
  [PURGE_AUTH](state) {
    // state.isLoggedIn = false;
    state.user = {};
    state.errors = [];
  },

  [SET_LOGOUT_ACC_FREE](state, value) {
    state.isAccFreeLogout = value;
  },

  [SET_LOGIN_POPUP](state, value) {
    state.loginPopupData = value;
  },

  [SET_TOGGLE_LOGIN_POPUP](state, value) {
    state.isOpenLoginForm = value;
  },

  [SET_TOGGLE_LOGIN_SSO_POPUP ](state, value) {
    state.isOpenLoginFormSSO = value;
  }
};